import { apiClient } from './client';
import { AuthUser, LoginRequest, VerifyOTPRequest, RegisterRequest, User } from '../types';

export const authApi = {
  /**
   * Send OTP to phone number
   */
  async sendOTP(data: LoginRequest) {
    return apiClient.post('/api/auth/send-otp', data);
  },

  /**
   * Verify OTP and authenticate
   */
  async verifyOTP(data: VerifyOTPRequest) {
    return apiClient.post<AuthUser>('/api/auth/verify-otp', data);
  },

  /**
   * Register new user
   */
  async register(data: RegisterRequest) {
    return apiClient.post<User>('/api/users', data);
  },

  /**
   * Create tenant for new user
   */
  async createTenant(phone: string) {
    return apiClient.post('/api/tenants', { phone });
  },

  /**
   * Get current authenticated user
   */
  async getCurrentUser() {
    return apiClient.get<User>('/api/auth/me');
  },
};
